import {
  every,
  filter,
  forEach,
  get,
  groupBy,
  includes,
  keys,
  map,
  mapKeys,
  omit,
  reverse,
  toString,
} from 'lodash'

const filterParentKeysWhenNotAllChildrenSelected = (checked, flatTreeData) => {
  let levelCounter = 0

  const checkedKeysGroupedByLevel = mapKeys(groupBy(checked, 'length'), () =>
    // eslint-disable-next-line no-plusplus
    toString(levelCounter++),
  )

  let result = get(checkedKeysGroupedByLevel, levelCounter, [])

  const levelsToIterate = reverse(
    keys(omit(checkedKeysGroupedByLevel, [levelCounter])),
  )

  forEach(levelsToIterate, level => {
    const checkedKeysOnLevel = get(checkedKeysGroupedByLevel, level)

    const checkedNodesOnLevel = filter(flatTreeData, node =>
      includes(checkedKeysOnLevel, node.key),
    )

    const nodesWithAllChildrenChecked = filter(
      checkedNodesOnLevel,
      ({ children }) =>
        every(children, childNode => includes(result, childNode.key)),
    )

    result = [...result, ...map(nodesWithAllChildrenChecked, 'key')]
  })

  return result
}

export default filterParentKeysWhenNotAllChildrenSelected
